"use strict";

exports.__esModule = true;
exports.openaq = void 0;

var fetchBy_1 = require("./fetchBy");

var normalize_1 = require("./normalize");

exports.openaq = {
  fetchByGps: fetchBy_1.fetchByGps,
  fetchByStation: fetchBy_1.fetchByStation,
  id: 'openaq',
  name: 'Open AQ',
  normalizeByGps: normalize_1.normalizeByGps,
  normalizeByStation: normalize_1.normalizeByStation
};